<div class="container bg-white">

  <div class="page">

    <div class="page-header pb-1">
      <h2 class="page-title">{{ 'Transfer account' | translate }}</h2>
    </div>

    <div class="page-body pb-3">

      <div *ngIf="isSubmitted">

        <p>{{ 'Great, you are almost done!' | translate }}</p>
        <p>{{ 'Click the button below to register an account and login' | translate }}</p>

        <button type="button" class="btn btn-primary mt-2" (click)="SignUp()">
          {{'Register' | translate}} / {{'Login' | translate}}
        </button>

      </div>

      <div *ngIf="!isSubmitted">

        <div [formGroup]="formGroup" class="">

          <div class="alert alert-info">
            <p>{{ 'Great that you want to continue on the meet the youngsters platform!' | translate}}</p>
            <p>{{ 'In order to transfer your Regio in je Rugzak profile, we would like to ask you which profile details you want to transfer here below.' | translate }}</p>
          </div>

          <div class="form">

            <div class="jumbotron mb-0">

              <p class="font-weight-bold">{{ 'Please select / deselect the details you want to transfer below.' | translate }}</p>

              <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="nawData" />
                <label class="form-check-label">{{ 'Name / Address / Residence details' | translate }}</label>
              </div>

              <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="interests" />
                <label class="form-check-label">{{ 'Area of interests' | translate }}</label>
              </div>

              <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="matchTest" />
                <label class="form-check-label">{{ 'Match test' | translate }}</label>
              </div>

              <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="latestDNA" />
                <label class="form-check-label">{{ 'Latest DNA' | translate }}</label>
              </div>

              <button [disabled]="isProcessing" *ngIf="!isSubmitted" type="button" class="btn btn-primary mt-2" (click)="onSubmit()">
                {{ 'Transfer my data' | translate}}
                <fa-icon *ngIf="isProcessing" [icon]="faSpinner"></fa-icon>
              </button>

              <p class="text-xs mt-2">*{{ 'After you press "transfer my data", new instructions follow' | translate}}</p>

            </div>

          </div>

        </div>

      </div>

    </div>


  </div>

</div>
